import { PayrollApi } from '../../../api/People/Payroll'
import Payroll from '../../../components/People/Payroll/Payroll'
import React from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'

function PayrollCont() {
  const { list: cached, fetching, fetch } = useFetchList(() => PayrollApi.list())
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)

  return (
    <Payroll
      {...{
        list,
        fetching,
        fetch,
        company,
        onChangeCompany,
      }}
    />
  )
}

export default PayrollCont
